import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from "@angular/core";
import {GroupModel} from "../../../models/group.model";

require('./groups-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-groups-table-row',
  templateUrl: './groups-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupsTableRowComponent implements OnChanges {

  @Input() group: GroupModel;
  @Input() allowEdit: boolean;
  @Input() allowDelete: boolean;
  @Output() editGroupEvent = new EventEmitter<GroupModel>();
  @Output() deleteGroupEvent = new EventEmitter<GroupModel>();

  public groupRGBAColor: any;

  constructor(@Inject('commonsService') private commonsService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.group && this.group) {
      if (this.group.displayColor) {
        this.groupRGBAColor = this.commonsService.hexToRGBColor(this.group.displayColor, 0.1);
      } else {
        this.groupRGBAColor = undefined;
      }
    }
  }

}
